<template>
    <footer class="footer container">
        <div class="footer__inner">
            <div class="footer__top">
                <div class="footer__logo-links">
                    <div class="footer__logo">
                        <img class="footer__logo-pic" 
                            src="@/assets/images/logo-zetta.png" 
                            alt="Логотип Zetta">
                    </div>
                    <div class="footer__links">
                        <ul class="footer__links-col">
                            <li class="footer__links-col-item"
                                v-for="link in footerLinksColOne"
                                :key="link.text">
                                <BaseLink :text="link.text"
                                    :path="link?.path"
                                    :target="link?.target"
                                    @click.native="scrollTo(link?.name)"
                                    />
                            </li>
                        </ul>
                        <ul class="footer__links-col">
                            <li class="footer__links-col-item"
                                v-for="link in footerLinksColTwo"
                                :key="link.text">
                                <BaseLink :text="link.text"
                                    :path="link?.path"
                                    :target="link?.target"
                                    @click.native="scrollTo(link?.name)"
                                    />
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="footer__phone">
                    <a class="footer__phone-text" href="tel:+78007007707">8 800 700 77 07</a>
                    <span class="footer__phone-comment">Горячая линия - круглосуточно</span>
                </div>
            </div>

            <div class="footer__bottom">
                <p class="footer__meta-text">ООО «Зетта Страхование» специализируется на обслуживании физических и юридических лиц. В соответствии с Лицензиями ЦБ РФ СИ №1083, СЛ №1083, ОС №1083-03, ОС №1083-04, ОС №1083-05, ПС №1083 от 24.06.2015 г. и ОС №1083-02 от 23.12.2019 г. Компания предоставляет более 90 программ страхования и перестрахования.</p>
                <div class="footer__author">
                    <span class="footer__author-text">Разработано в</span>
                    <div class="footer__author-img">
                        <img class="footer__author-img-pic" src="@/assets/images/qsoft-logo.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import BaseLink from '@/components/ui/BaseLink.vue';
import scrollTo from '@/mixins/scrollTo';

export default {
    name: 'TheFooter',
    components: {
        BaseLink
    },
    mixins: [scrollTo],
    data() {
        return {
            footerLinksColOne: [
                {text: 'Оформить', name: 'process'},
                {text: 'Преимущества', name: 'advantages'},
                {text: 'Частые вопросы', name: 'faq'},
            ],
            footerLinksColTwo: [
                {text: 'Правила страхования', path: 'https://zettains.ru/calculators/ya-taxi/pravila.pdf', target: '_blank'},
                {text: 'Образец договора страхования', path: '', target: '_blank'},
                {text: 'Условия принятия на страхование', path: '', target: '_blank'},
            ]
        }
    }
}
</script>

<style scoped lang="scss">

.footer {
    &__inner {
        padding: rem($gap-big);

        border-radius: rem($border-radius-medium);
        background-color: $primary-invert;
    }

    &__top {
        display: flex;
        justify-content: space-between;

        @media #{$screen-small} {
            flex-direction: column;
        }
    }

    &__logo-links {
        @media #{$screen-small} {
            margin-bottom: rem($gap-big);
        }
    }

    &__logo {
        $width-desktop: 127px;
        $height-desktop: 46px;

        $width-desktop-min: 110px;
        $height-desktop-min: 40px;

        width: rem($width-desktop);
        height: rem($height-desktop);

        @media #{$screen-big} {
            width: rem($width-desktop-min);
            height: rem($height-desktop-min);
        }

        &-pic {
            @include object-contain-full;
        }
    }

    &__links {
        display: flex;

        margin-top: rem($gap-medium);

        
        @media #{$screen-small} {
            flex-direction: column;
        }

        &-col {
            display: flex;
            flex-direction: column;

            margin-left: rem($gap-xxl);

            @media #{$screen-big} {
                margin-left: rem($gap-large);
            }

            @media #{$screen-medium} {
                margin-left: rem($gap-big);
            }
            
            @media #{$screen-small} {
                margin-left: 0;
            }

            &:first-child {
                margin-left: 0;

                @media #{$screen-small} {
                    margin-bottom: rem($gap-normal);
                }
            }

            &-item {
                @include resetting-vertical-indentation-of-first;

                line-height: 1;

                margin-top: rem($gap-normal);
            }
        }
    }

    &__phone {
        flex-shrink: 0;

        &-text {
            @include text-xxl($font-weight-bold, $line-height-normal);

            text-decoration: none;

            @media #{$screen-big} {
                font-size: rem($font-size-xl);
            }

            @media #{$screen-medium} {
                font-size: rem($font-size-huge);
            }
        }

        &-comment {
            @include  text-normal($font-weight-regular, $line-height-normal);

            display: block;

            margin-top: rem($gap-mini);
            text-align: end;

            color: $color-text-muted;

            @media #{$screen-big} {
                font-size: rem($font-size-small);
            }

            @media #{$screen-medium} {
                font-size: rem($font-size-mini);
            }

            @media #{$screen-small} {
                text-align: start;
            }
        }
    }

    &__bottom {
        display: flex;
        justify-content: space-between;

        margin-top: rem($gap-big);

        @media #{$screen-small} {
            flex-direction: column;

            margin-top: rem($gap-medium);
        }
    }

    &__meta-text {
        $safe-margin: 30px;

        @include text-mini;

        width: 75%;
        margin-right: rem($safe-margin);

        color: $color-text-muted;
    }

    &__author {
        display: flex;
        align-items: center;

        align-self: flex-end;

        @media #{$screen-small} {
            align-self: flex-start;

            margin-top: rem($gap-big);
        }

        &-text {
            @include text-mini($font-weight-regular, $line-height-medium);

            white-space: nowrap;

            color: $color-text-muted;
        }

        &-img {
            $width-desktop: 70px;
            $height-desktop: 16px;

            width: rem($width-desktop);
            height: rem($height-desktop);

            margin-left: rem(6px);

            &-pic {
                @include object-contain-full;
            }
        }
    }
}
</style>